import EmailIntegration from "./definitions/EmailIntegration";
import DeleteIntegration from "./definitions/DeleteIntegration";
import WebDAVIntegration from "./definitions/WebDAVIntegration";
import ExcelIntegration from "./definitions/ExcelIntegration";
import FTPSIntegration from "./definitions/FTPSIntegration";
import MongoDBIntegration from "./definitions/MongoDBIntegration";
import OneDriveIntegration from "./definitions/OneDriveIntegration";
import TaskIntegration from "./definitions/TaskIntegration";
import GoogleSheetsCellUpdateIntegration from "./definitions/GoogleSheetsCellUpdateIntegration";
import GoogleSheetsIntegration from "./definitions/GoogleSheetsIntegration";
import WordIntegration from "./definitions/WordIntegration";
import type { IntegrationDefinition, IntegrationType } from "./types";

export const integrationsByType = {
  mail: EmailIntegration,
  delete: DeleteIntegration,
  excel: ExcelIntegration,
  sftp: FTPSIntegration,
  googlesheetupdate: GoogleSheetsCellUpdateIntegration,
  googlesheets: GoogleSheetsIntegration,
  mongodbinsert: MongoDBIntegration,
  onedrive: OneDriveIntegration,
  task: TaskIntegration,
  webdav: WebDAVIntegration,
  word: WordIntegration,
} as Record<IntegrationType, IntegrationDefinition<unknown, unknown>>;

export const toIntegration = (type: IntegrationType): IntegrationDefinition<unknown, unknown> =>
  integrationsByType[type];
